import React from "react"

type OwnProps = {
    title: string
    description: string
    displayImage?: boolean
    image?: JSX.Element
}

const BaseNoResults = (props: OwnProps) => {
    return (
        <div className="col-12 ui-module d-flex align-items-center gap-3 mt-4 p-4">
            { props.displayImage && <div className="p-2">{props.image}</div> }
            <div className="d-flex flex-column gap-1">
                <div className="h5 mb-0">{props.title}</div>
                <div className="text-muted">{props.description}</div>
            </div>
        </div>
    )
}

export default BaseNoResults


// WEBPACK FOOTER //
// ./src/common/no-result/BaseNoResult.tsx